export const required = value => (value || typeof value === 'number' ? undefined : 'обязательное поле')
export const minLength = min => value =>
  value && value.length < min ? `слишком мало символов` : undefined